import React, { useState, useEffect } from "react";
import UserNavbar from "./UserNavbar";
import { getEndPoint } from "../components/request";
import { Button, Modal, Dropdown, Form, Spinner } from "react-bootstrap";
import "../css/StudentData.css";

const StudentData = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [filterBy, setFilterBy] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  
  // Fetch all placements when the component loads
  useEffect(() => {
    const fetchPlacements = async () => {
      setIsLoading(true);
      try {
        const response = await getEndPoint('/data/placements/filter', null);
        setFilteredData(response.data);
      } catch (error) {
        console.error("Failed to fetch placements:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchPlacements();
  }, []);

  // Search function to filter placements based on searchQuery
  const handleSearch = async () => {
    if (!searchQuery.trim() && filterBy !== "all") return;
  
    setIsLoading(true);
    try {
      const response = await getEndPoint(
        `/data/placements/filter?filterBy=${filterBy}&searchQuery=${encodeURIComponent(searchQuery)}`, 
        null
      );
      setFilteredData(response.data);
    } catch (error) {
      console.error("Search failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to return filtered placements based on selected filter
  const filteredPlacements = () => {
    if (filterBy === "all") return filteredData;

    return filteredData.filter((placement) => {
      if (filterBy === "company") {
        return placement.namePlacement.toLowerCase().includes(searchQuery.toLowerCase());
      }
      if (filterBy === "role") {
        return placement.rolePlacement.toLowerCase().includes(searchQuery.toLowerCase());
      }
      if (filterBy === "category") {
        return placement.category.toLowerCase().includes(searchQuery.toLowerCase());
      }
      if (filterBy === "type") {
        return placement.type.toLowerCase().includes(searchQuery.toLowerCase());
      }
      if (filterBy === "location") {
        return placement.location.toLowerCase().includes(searchQuery.toLowerCase());
      }
      return true;
    });
  };

  return (
    <div>
      <UserNavbar type={6} />

      <div className="filter-section">
        <div className="filter-container">
          <Dropdown>
            <Dropdown.Toggle variant="primary" id="dropdown-basic">
              Filter By: {filterBy.charAt(0).toUpperCase() + filterBy.slice(1)}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => setFilterBy("all")}>All</Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterBy("company")}>Company</Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterBy("role")}>Role</Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterBy("category")}>Category</Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterBy("type")}>Type</Dropdown.Item>
              <Dropdown.Item onClick={() => setFilterBy("location")}>Location</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {filterBy !== "all" && (
          <div className="search-container">
            <div className="search-input-group">
              <Form.Control
                type="text"
                placeholder={`Search by ${filterBy}...`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && searchQuery.trim()) {
                    handleSearch();
                  }
                }}
              />
              <Button variant="primary" onClick={handleSearch} disabled={!searchQuery.trim() || isLoading}>
                {isLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Search"}
              </Button>
            </div>
          </div>
        )}
      </div>

      <div className="card-box">
        {isLoading ? (
          <Spinner animation="border" />
        ) : filteredPlacements().length > 0 ? (
          filteredPlacements().map((placement, index) => (
            <div className="card individual-card" key={index}>
              <div className="card-body">
                <h5 className="card-title">{placement.namePlacement}</h5>
                <p className="card-text"><strong>Role:</strong> {placement.rolePlacement}</p>
                <Button onClick={() => setModalContent(placement) || setShowModal(true)}>View More</Button>
              </div>
            </div>
          ))
        ) : (
          <p>No placements found.</p>
        )}
      </div>

      {/* Modal to Display Placement Details */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalContent?.namePlacement}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalContent && (
            <>
               <p><strong>Role:</strong> {modalContent.rolePlacement}</p>
              <p><strong>Description:</strong> {modalContent.roleDescription}</p>
              <p><strong>Location:</strong> {modalContent.location}</p>
              <p><strong>Industry Sector:</strong> {modalContent.industrySector}</p>
              <p><strong>Type:</strong> {modalContent.type}</p>
              <p><strong>Size:</strong> {modalContent.size}</p>
              <p><strong>Category:</strong> {modalContent.category}</p>
              <p><strong>Opening:</strong> {modalContent.opening}</p>

              <h5>Background Experience</h5>
              <ul>
                <li><strong>Academic Projects:</strong> {modalContent.backgroundExperience.academicProjects ? "Yes" : "No"}</li>
                <li><strong>Previous Internships:</strong> {modalContent.backgroundExperience.previousInternships ? "Yes" : "No"}</li>
                <li><strong>Relevant Coursework:</strong> {modalContent.backgroundExperience.relevantCoursework ? "Yes" : "No"}</li>
                <li><strong>Technical Work:</strong> {modalContent.backgroundExperience.technicalWork}</li>
                <li><strong>Others:</strong> {modalContent.backgroundExperience.others}</li>
              </ul>

              <h5>Technical Interview</h5>
              <ul>
                <li><strong>LeetCode:</strong> {modalContent.technicalInterview.leetCode ? "Yes" : "No"}</li>
                <li><strong>DSA:</strong> {modalContent.technicalInterview.dsa ? "Yes" : "No"}</li>
                <li><strong>Mock Interviews:</strong> {modalContent.technicalInterview.mockInterviews ? "Yes" : "No"}</li>
                <li><strong>Previous Work:</strong> {modalContent.technicalInterview.previousWork ? "Yes" : "No"}</li>
                <li><strong>Others:</strong> {modalContent.technicalInterview.others}</li>
              </ul>

              <h5>Technical Skills</h5>
              <ul>
                <li><strong>Programming Languages:</strong> {modalContent.techSkills.progLang}</li>
                <li><strong>Frameworks:</strong> {modalContent.techSkills.framework}</li>
                <li><strong>Previous Projects:</strong> {modalContent.techSkills.prevProjects ? "Yes" : "No"}</li>
                <li><strong>Problem Solving:</strong> {modalContent.techSkills.problemSolving ? "Yes" : "No"}</li>
                <li><strong>Tech DSA:</strong> {modalContent.techSkills.techdsa ? "Yes" : "No"}</li>
                <li><strong>Version Control:</strong> {modalContent.techSkills.vcs ? "Yes" : "No"}</li>
                <li><strong>Others:</strong> {modalContent.techSkills.others}</li>
              </ul>

              <h5>Interview Types</h5>
              {modalContent.interviewTypes.length > 0 ? (
                <ul>
                  {modalContent.interviewTypes.map((interview, idx) => (
                    <li key={idx}>
                      <strong>{interview.roundName}:</strong> {interview.details}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No interview rounds available.</p>
              )}

              <h5>Preparation Methods</h5>
              <p>{modalContent.preparationMethods.length > 0 ? modalContent.preparationMethods.join(", ") : "No specific methods mentioned."}</p>

              <h5>Networking Experience</h5>
              <p>{modalContent.networkingExperience || "Not mentioned"}</p>

              <h5>Highlighted Skills</h5>
              <p>{modalContent.highlightedSkills.length > 0 ? modalContent.highlightedSkills.join(", ") : "No skills highlighted."}</p>

              <h5>Technical Questions</h5>
              <p>{modalContent.technicalQuestions.length > 0 ? modalContent.technicalQuestions.join(", ") : "No technical questions mentioned."}</p>

              <h5>Advice</h5>
              <p>{modalContent.advice || "No advice given."}</p>

              <h5>Overall Satisfaction</h5>
              <p>{modalContent.satisfactionRating || "Not rated."}</p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default StudentData;
